import Cookie from 'js-cookie';
import { RefreshToken } from '@/connections/auth';
import { getEnv } from '@/utils/env';
import { PageRequest } from '@/route-handlers/page-request';
import { isLocalhostUrl } from '../validation/urls';

/**
 * Client-side equivalent of redirectIfLoggedIn. SameSite: strict cookies are not sent on
 * cross-origin navigations, so the server loader cannot detect an existing session. This
 * function checks client-side: if a refreshToken cookie is present and the token refreshes
 * successfully, it navigates to checkCookie and suspends the caller indefinitely. If not
 * logged in or the token is invalid it returns normally so the caller can proceed.
 */
export async function redirectIfLoggedInClient(params: PageRequest): Promise<void> {
  // Localhost uses localstorage instead of cookies, so we need to skip the refresh check
  if (isLocalhostUrl(params.redirect_uri)) {
    return;
  }

  const refreshToken = Cookie.get('refreshToken');
  if (!refreshToken) return;

  try {
    await RefreshToken();

    if (params.from_app) {
      const checkCookieUrl = new URL(`${getEnv().VITE_API_HOST}/v4/admin/auth/checkCookie`);
      checkCookieUrl.search = params.toParams();
      window.location.replace(checkCookieUrl.href);
      await new Promise<never>(() => {});
    }

    window.location.replace('/channels');
  } catch (error) {
    // Refresh token is invalid — fall through and show the sign-in form
    console.warn('Refresh token is invalid', error);
  }
}
